import { httpClient } from "@/shared/http/httpClient";
import { InvestorsDashboardData } from "@/features/investors/types/investors.types";

const BASE_PATH = "/api/v1/analytics/investors";

const fetchInvestorsDashboard = (start: string, end: string): Promise<InvestorsDashboardData> => {
    const params = new URLSearchParams({ start, end });
    return httpClient.getJson<InvestorsDashboardData>(`${BASE_PATH}?${params.toString()}`);
};

export const investorsApi = { fetchInvestorsDashboard };
